import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { useDispatch } from "react-redux";
import { toastService } from "../../utils/toastify";
import { editFAQ, getFAQ } from "../../features/slices/faqManagement";
const initialState = {
  question: "",
  answer: "",
};
const EditFAQ = ({ setUpdateState, faqData }) => {
  const [iState, setIState] = useState(initialState);
  const [errors, setErrors] = useState({});
  const { question, answer } = iState;
  const disptach = useDispatch();
  const handleClose = (e) => {
    setUpdateState((prev) => ({ ...prev, showEditFaq: false }));
  };
  useEffect(() => {
    if (faqData) {
      setIState({
        question: faqData.question || "",
        answer: faqData.answer || "",
      });
    }
  }, [faqData]);
  const handleChange = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    const { name, value } = e.target;
    setIState((prev) => ({ ...prev, [name]: value }));
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!question?.trim()) {
      formErrors.question = "question is required.";
      isValid = false;
    }
    if (!answer?.trim()) {
      formErrors.answer = "answer is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };
  const handleEditFAQ = (e) => {
    const payload = {
      faqId: faqData?._id,
      question: question,
      answer: answer,
    };
    if (validateForm()) {
      disptach(editFAQ(payload)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Faq added successfully");
          disptach(getFAQ());
          handleClose();
        } else {
          toastService.error(res?.payload?.message);
        }
      });
    }
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Edit Faq</h3>
          <div className="form-group">
            <label>Faq Question</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Faq Question"
              name="question"
              value={question}
              onChange={handleChange}
            />
            {errors.question && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.question}
              </p>
            )}
          </div>
          <div className="form-group">
            <label>Faq Answer</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Faq Answer"
              name="answer"
              value={answer}
              onChange={handleChange}
            />
            {errors.answer && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.answer}
              </p>
            )}
          </div>

          <div className="Buttons">
            <button className="Button ml-0" onClick={handleEditFAQ}>
              Edit Faq
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditFAQ;
